import { render, staticRenderFns } from "./DsTextarea.vue?vue&type=template&id=352b78b6&scoped=true&"
import script from "./DsTextarea.vue?vue&type=script&lang=js&"
export * from "./DsTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DsTextarea.vue?vue&type=style&index=0&id=352b78b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b78b6",
  null
  
)

export default component.exports